export enum SummaryTypes {
  AvaliableInvested,
  Liquidate,
  Composition,
  Withdrawl
}
